import React from 'react'
import { CardLayout, RichTextEditor } from '../../Molecules';
import { DataTable } from '.';
import { BiSolidEdit } from 'react-icons/bi';
import { FaTimes } from 'react-icons/fa';
import { ImBin } from 'react-icons/im';
import { Button, InputWithLabel, PageHeading, Switch, UploadFile } from '../../Atoms';
import { DeleteModalComponent } from '../modal/delete';
import { ModalComponent } from '../modal';
import { BsCheck } from 'react-icons/bs';
import { FaEye } from 'react-icons/fa6';

export const CategoriesTable = () => {

    const [deleteModal, setDeleteModal] = React.useState(false);
    const [viewModal, setViewModal] = React.useState(false);
    const [categoryModal, setCategoryModal] = React.useState(false);
    const [importModal, setImportModal] = React.useState(false);
    const [content, setContent] = React.useState('')

    const statusColor = {
        'No': "bg-red-light dark:bg-transparent text-red border-2 border-red ",
        'Yes': "bg-green-light dark:bg-transparent text-green border-2 border-green ",
    }

    const statusIcons = {
        'Yes': <BsCheck />,
        'No': <FaTimes className='text-xs' />,
    }

    const columns = [
        {
            name: "name",
            label: "Name",
            filter: true,
            sort: true,
            sortOrder: "desc",
            visible: true,
        },
        {
            name: "slug",
            label: "Slug",
            filter: true,
            sort: true,
            sortOrder: "desc",
            visible: true,
        },
        {
            name: "visibility",
            label: "Visibility",
            filter: true,
            sort: true,
            sortOrder: "desc",
            visible: true,
            customComponent: (props) => {
                return (
                    <div className='flex items-center justify-center'>
                        <span className={`w-5 h-5 p-1 flex items-center space-x-1 justify-center text-xs leading-5 font-semibold rounded-full ${statusColor[props?.visibility]} p-0.5 `}>
                            <div className='text-sm'>{statusIcons[props.visibility]}</div>
                        </span>
                    </div>
                );
            },
        },
        {
            name: "last_updated",
            label: "Last Updated",
            filter: true,
            sort: true,
            sortOrder: "desc",
            visible: true,
        },
        {
            name: "",
            label: "Action",
            filter: true,
            sort: true,
            sortOrder: "desc",
            visible: true,
            customComponent: (props) => {
                return (
                    <div className='flex items-center justify-center space-x-3'>
                        <div
                            onClick={() => {

                                setViewModal(!viewModal)
                                setContent(props)
                            }}
                            className='text-gray-icon cursor-pointer flex items-center justify-center space-x-1 text-sm'>
                            <div><FaEye className='text-lg' /></div>
                            <div className='font-medium text-gray-text'>View</div>
                        </div>
                        <div
                            onClick={() => setCategoryModal(!categoryModal)}
                            className='text-orange cursor-pointer flex items-center justify-center space-x-1 text-sm'>
                            <div><BiSolidEdit className='text-lg' /></div>
                            <div className='font-medium'>Edit</div>
                        </div>
                        <div
                            onClick={() => setDeleteModal(!deleteModal)}
                            className='text-red cursor-pointer flex items-center justify-center space-x-1 text-sm'>
                            <div><ImBin className='text-lg' /></div>
                            <div className='text-red font-medium'>Delete</div>
                        </div>
                    </div>
                );
            },
        },

    ];

    const data = [
        {
            id: 1,
            name: 'Street 1',
            slug: '123456',
            description: 'Any thing cool is working',
            visibility: 'Yes',
            last_updated: '12/12/2021',

        },
    ]

    const options = {
        paginationTop: true,
        paginationBottom: true,
    };

    const onSubmitForm = (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const data = Object.fromEntries(formData)
        console.log(data)
        // navigate('/dashboard')
    }

    const ImportModalBody = (
        <form
            onSubmit={onSubmitForm}
            className='p-5 border dark:border-gray-dark dark:bg-black-PRIMARY rounded-md dark:text-white'
        >
            <div className=' flex items-center justify-between pb-3'>
                <div className='text-xl font-semibold'>
                    Import Categories
                </div>
                <div>
                    <FaTimes
                        onClick={() => setImportModal(!importModal)}
                        className='text-gray-icon cursor-pointer' />
                </div>
            </div>
            <div className='text-orange text-xs md:text-sm pb-2 font-semibold hover:underline hover:duration-300'>
                Download example CSV file
            </div>
            <div>
                <UploadFile
                    title={'Upload a CSV file'}
                    name={'file'}
                    id={'file'}
                    accept={'.csv'}
                />
            </div>

            <div className='flex items-center mt-5 space-x-2'>
                <Button
                    title={'Import'}
                    type={'submit'}
                    textSize={'text-xs md:text-sm  px-4'}
                    height={'h-8 md:h-10'}
                    background={'bg-orange'}
                    color="text-white"
                    border={true}
                />
                <Button
                    title={'Cancel'}
                    type={'button'}
                    onButtonPressed={() => setImportModal(!importModal)}
                    textSize={'text-xs md:text-sm max-w-min px-4'}
                    height={'h-8 md:h-10'}
                    background={'bg-white'}
                    color="text-black"
                    border={true}
                />
            </div>
        </form>
    )

    const CategoryModalBody = (<form
        onSubmit={onSubmitForm}
        className='p-5 border dark:border-gray-dark dark:bg-black-PRIMARY rounded-md dark:text-white'
    >
        <div className='flex items-center justify-between pb-6'>
            <div className='text-xl font-semibold'>
                Create address
            </div>
            <div>
                <FaTimes
                    onClick={() => setCategoryModal(!categoryModal)}
                    className='text-gray-icon cursor-pointer' />
            </div>
        </div>
        <div
            className=' grid md:grid-cols-2 gap-4'
        >
            <InputWithLabel
                title={'Name'}
                name="name"
                placeholder='Enter name'
                password={false}
                type={'text'}
                isRequired={true}
            />
            <InputWithLabel
                title={'Slug'}
                name="slug"
                placeholder='Enter slug'
                password={false}
                type={'text'}
                disabled={true}
                isRequired={false}
            />

            <div className='md:col-span-2'>
                <RichTextEditor
                    name="description"
                    title="Description"
                    isRequired={false}
                />
            </div>
            <div>
                <Switch title="Visible to Customers." />
            </div>
        </div>


        <div className='flex items-center mt-5 space-x-2'>
            <Button
                title={'Create'}
                onButtonPressed={() => setCategoryModal(!categoryModal)}
                type={'submit'}
                textSize={'text-xs md:text-sm max-w-min px-4'}
                height={'h-8 md:h-10'}
            />
            <Button
                title={'Create & create another'}
                type={'submit'}
                textSize={'text-xs md:text-sm  px-4'}
                height={'h-8 md:h-10'}
                background={'bg-white'}
                color="text-black"
                border={true}
            />
            <Button
                title={'Cancel'}
                type={'button'}
                onButtonPressed={() => setCategoryModal(!categoryModal)}
                textSize={'text-xs md:text-sm max-w-min px-4'}
                height={'h-8 md:h-10'}
                background={'bg-white'}
                color="text-black"
                border={true}
            />
        </div>

    </form>
    )

    const ViewModalBody = (<form
        onSubmit={onSubmitForm}
        className='p-5 border dark:border-gray-dark dark:bg-black-PRIMARY rounded-md dark:text-white'
    >
        <div className='flex items-center justify-between pb-6'>
            <div className='text-xl font-semibold'>
                View ${content?.name}
            </div>
            <div>
                <FaTimes
                    onClick={() => setViewModal(!viewModal)}
                    className='text-gray-icon cursor-pointer' />
            </div>
        </div>
        <div className='flex flex-col space-y-4'>
            <div className='grid grid-cols-2 gap-2'>
                <div className='text-sm font-semibold pb-2'>Name</div>
                <div className='text-sm line-clamp-1'>{content?.name}</div>
            </div>
            <div className='grid grid-cols-2 gap-2'>
                <div className='text-sm font-semibold pb-2'>Slug</div>
                <div className='text-sm line-clamp-1'>{content?.slug}</div>
            </div>
            <div className='grid grid-cols-2 gap-2'>
                <div className='text-sm font-semibold pb-2'>Description</div>
                <div className='text-sm line-clamp-3'>{content?.description}</div>
            </div>
            <div className='grid grid-cols-2 gap-2'>
                <div className='text-sm font-semibold pb-2'>Visibility</div>
                <div className='flex items-center'>
                    <span className={`w-5 h-5 p-1 flex items-center space-x-1 justify-center text-xs leading-5 font-semibold rounded-full ${statusColor[content?.visibility]} p-0.5 `}>
                        <div className='text-sm'>{statusIcons[content?.visibility]}</div>
                    </span>
                </div>
            </div>
            <div className='grid grid-cols-2 gap-2'>
                <div className='text-sm font-semibold pb-2'>Updated at</div>
                <div className='text-sm line-clamp-1'>{content?.last_updated}</div>
            </div>

        </div>


        <div className='flex items-center mt-5 space-x-2'>
            <Button
                title={'Close'}
                type={'button'}
                onButtonPressed={() => setViewModal(!viewModal)}
                textSize={'text-xs md:text-sm max-w-min px-4'}
                height={'h-8 md:h-10'}
                background={'bg-white'}
                color="text-black"
                border={true}
            />
        </div>

    </form>
    )
    return (
        <div className=''>
            <div className=' mb-4 flex items-center justify-between'>
                <PageHeading title='Categories' />
                <div className='flex space-x-2'>
                    <Button
                        title='Import Categories'
                        type={"button"}
                        textSize={"text-xs md:text-sm"}
                        height={"h-9 w-36"}
                        background={'bg-white'}
                        color={'text-black'}
                        border={true}
                        onButtonPressed={() => setImportModal(!importModal)}
                    />
                    <Button
                        title='New category'
                        type={"button"}
                        textSize={"text-xs md:text-sm"}
                        height={"h-9 w-36"}
                        onButtonPressed={() => setCategoryModal(!categoryModal)}
                    />
                </div>

            </div>

            <ModalComponent
                style="w-11/12 sm:w-10/12 md:w-1/2  2xl:w-[22%] top-[25%] lg:top-[30%] "
                modal={categoryModal}
                onModalStatus={() => setCategoryModal(!categoryModal)}
                content={CategoryModalBody}
            />

            <DeleteModalComponent
                onModalStatus={() => setDeleteModal(!deleteModal)}
                modal={deleteModal}
                type={'delete'}
            />

            <ModalComponent
                style="w-11/12 sm:w-10/12 md:w-1/2 lg:w-4/12  2xl:w-[22%] top-[25%] lg:top-[30%] "
                modal={importModal}
                onModalStatus={() => setImportModal(!importModal)}
                content={ImportModalBody}
            />

            <ModalComponent
                style="w-11/12 sm:w-10/12 md:w-1/2  2xl:w-[22%] top-[25%] lg:top-[30%] "
                modal={viewModal}
                onModalStatus={() => setViewModal(!viewModal)}
                content={ViewModalBody}
            />

            <CardLayout
                showTitle={false}
                title=''
                button={false}
                customButtonsStatus={false}
                content={<DataTable
                    data={data}
                    groupBy={false}
                    columns={columns} options={options} />}
            />
        </div>


    )
}
